import Vue from 'vue'
import {
  Button, Icon, Toast, Notify, Dialog, Image, Empty, Skeleton, Checkbox, CheckboxGroup, Radio, RadioGroup,
  Field, Popup, Switch, Cell, CellGroup, Form, Tab, Tabs, List, Uploader,
  PullRefresh, ActionSheet, NavBar, NoticeBar, Picker
} from 'vant'

Vue.use(Button).use(Icon).use(Dialog).use(Image).use(Empty).use(Skeleton).use(Checkbox).use(CheckboxGroup).use(Radio).use(RadioGroup).use(Field).use(Popup)
  .use(Switch).use(Cell).use(CellGroup).use(Form).use(Tabs).use(Tab).use(List).use(PullRefresh).use(ActionSheet).use(Uploader)
  .use(NavBar).use(NoticeBar).use(Picker)

Vue.prototype.$toast = Toast
Vue.prototype.$notify = Notify
Vue.prototype.$dialog = Dialog
